import store from "@/services/store";
function datalist(index)
{
	let returnValue =  store.state.crudStore.lists.datos_afiliado.filter(list => list.id===index)[0].name
	return returnValue
}
export default {
	data(){
		return {
			tableGBoptions: { 
				options: { anular: 'Anular Autorización'},
				modals: [
					{
						modal: "Autorizar",
						variant: "info",
						icon: "check-circle",
						title: "Autorizar",
						movil: true
					},
				]
			},

			tableGBSearch: ['list_users/name'],
			
			tableGBItems: [	
				{
					thead: { th: 'Afiliado', movil:true },
					tbody: { td: ['autorizar/cambios'], ftn: function(values) { var items = JSON.parse(values);
							if(items[0]!==undefined)
							{
								items=items[0] 
							}							
							if(items.datos_afiliado!==undefined)
							{
								return datalist(items.datos_afiliado.id)
							}
							if(items.info_aportes!==undefined)
							{
								return items.info_aportes.name
							}
							if(items.info_ingresos!==undefined)
							{
								return items.info_ingresos.name
							}
							if(items.info_ingresos!==undefined)
							{
								return items.info_ingresos.name
							}
							if(items.info_egresos!==undefined)
							{
								return items.info_egresos.name
							}
							return null
						}
					}
						
				},			
				{
					thead: { th: 'Radicador', sort: null, sortTable: 'list_users/name'},
					tbody: { td: ['list_users/name'],}
				},
				{
					thead: { th: 'Tipo',movil:true},
					tbody: { td: ['autorizar/eliminar'],}
				},
				{
					thead: { th: 'Motivo', },
					tbody: { td: ['autorizar/nota'],}
				},
			]			
		}
	},
}